// extracted by mini-css-extract-plugin
module.exports = {"card":"CertificateComponent_card__XfcMZ","details":"CertificateComponent_details__6_x6S"};